module.exports = __webpack_public_path__ + "img/22.f000a419.png";